<crm-single-select
  #singleSelectComponent
  [options]="entities"
  [(selectedItem)]="_selectedEntity"
  (selectedItemChange)="onSelect($event)"
  [label]="labelInput ? 'Внешний пользователь' : ''"
  [disabled]="disabled"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [isTemplateCombined]="true"
  [scrollHeight]="'300px'"
  [sort]="''"
  (onShow)="onShowPanel()"
  (onHide)="onHidePanel()"
  (onFilter)="search($event.filter)"
  [appendTo]="appendTo"
  [showClear]="showClear"
  [loading]="loading || selectionLoading"
  filterBy="profile.name,profile.email,profile.phone"
  optionLabel="id">
  <ng-template
    #itemTemplate
    let-user="item">
    <ng-container *ngIf="toExternalUser(user) as user">
      <div class="flex align-items-center gap-2">
        <div>
          <span [innerHTML]="highlightMatchText(user.profile?.name) | safeHtml"></span>
        </div>
        <div
          *ngIf="user?.deleted"
          class="font-medium text-red-500">
          (удалён)
        </div>
      </div>
      <div class="text-sm text-500">{{ user.profile?.email }}</div>
      <div
        *ngIf="user.profile?.phone"
        class="text-sm frm-color-green">
        {{ user.profile?.phone | phone }}
      </div>
    </ng-container>
  </ng-template>

  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
